//
// locale_no.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/no.json';
import localeData from "react-intl/locale-data/no.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
